import * as React from 'react'
import { useSelector } from 'react-redux'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Badge from '@mui/material/Badge'
import PersonIcon from '@mui/icons-material/Person'
import {
  selectSalespersonFilterOptions,
  selectSalespersonFilterSelection,
} from '@user/store/map'
import { computeBadgeCount } from '@user/components/HereMap/HereMapNew/hooks/useSalespersonFilter.utils'

type Props = {
  onOpen: () => void
}

export function SalespersonFilterButton({ onOpen }: Props) {
  const options = useSelector(selectSalespersonFilterOptions)
  const selection = useSelector(selectSalespersonFilterSelection)
  const badgeCount = computeBadgeCount(selection, options)

  return (
    <Paper elevation={4}>
      <IconButton
        sx={{ p: 1 }}
        onClick={onOpen}
        aria-label="Filter by salesperson"
        data-testid="salesperson-filter-button"
      >
        <Badge
          data-testid="salesperson-filter-badge"
          badgeContent={badgeCount ?? 0}
          invisible={badgeCount === null}
          color="primary"
        >
          <PersonIcon fontSize="small" />
        </Badge>
      </IconButton>
    </Paper>
  )
}
